var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 9,
  fill: "none",
  "data-coloringtype": "stroke",
  viewBox: "0 0 11 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00B341",
  strokeWidth: 2,
  d: "M.686 4.245 3.32 6.728l6.366-6"
})));
export default SvgSmallTick;